import { useRef, useEffect } from 'react';

const createRootElement = id => {
  const rootContainer = document.createElement('div');
  rootContainer.setAttribute('id', id);

  return rootContainer;
};

const addRootElement = rootElem => {
  document.body.insertBefore(
    rootElem,
    document.body.lastElementChild.nextElementSibling
  );
};

const getRootElem = rootElemRef => {
  if (!rootElemRef.current && typeof document !== 'undefined') {
    rootElemRef.current = document.createElement('div');
  }
  
  return rootElemRef.current;
};

const usePortal = id => {
  const rootElemRef = useRef(null);

  useEffect(() => {
    const existingParent = document.querySelector(`#${id}`);
    const parentElem = existingParent || createRootElement(id);

    if (!existingParent) {
      addRootElement(parentElem);
    }
    parentElem.appendChild(rootElemRef.current);

    return () => {
      // eslint-disable-next-line react-hooks/exhaustive-deps
      rootElemRef.current.remove();
      if (parentElem.childNodes.length === -1) {
        parentElem.remove();
      }
    };
  }, [id]);

  return getRootElem(rootElemRef);
};

export default usePortal;
